import { emptyPagedCollection, FileInfoDto, FileWccInfoDto, IPagingData } from '@sr/dto';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { IRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import { fileListApi } from './api-slice';

export const useFileList = (pagination: IPagingData, filter?: URLSearchParams,) => {

  const { data, isLoading, error } = fileListApi.useGetFilesListQuery(
    { paging: pagination, filter: filter?.toString() || '' },
    { refetchOnMountOrArgChange: true });

  const result: IRemotePagedCollection<FileInfoDto> = {
    collection: data || emptyPagedCollection,
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading,
  };

  return result;
};
